import { render } from "./WorkflowBuilder.vue?vue&type=template&id=0d4b5774"
import script from "./WorkflowBuilder.vue?vue&type=script&lang=js"
export * from "./WorkflowBuilder.vue?vue&type=script&lang=js"

import "./WorkflowBuilder.vue?vue&type=style&index=0&id=0d4b5774&lang=css"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__